namespace GeniuzPOS.QRreport {
    export interface QRywcSpec1319Form {
        ReportId: Serenity.LookupEditor;
        ReportName: Serenity.StringEditor;
        UrlReport: Serenity.StringEditor;
        DataStructureName: Serenity.StringEditor;
        LineNo: Serenity.IntegerEditor;
        DateBegin: Serenity.DateEditor;
        DateEnd: Serenity.DateEditor;
        ShopId: Serenity.LookupEditor;
        PromoCampaign: Serenity.LookupEditor;
    }

    export class QRywcSpec1319Form extends Serenity.PrefixedContext {
        static formKey = 'QRreport.QRywcSpec1319';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!QRywcSpec1319Form.init)  {
                QRywcSpec1319Form.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;
                var w2 = s.IntegerEditor;
                var w3 = s.DateEditor;

                Q.initFormType(QRywcSpec1319Form, [
                    'ReportId', w0,
                    'ReportName', w1,
                    'UrlReport', w1,
                    'DataStructureName', w1,
                    'LineNo', w2,
                    'DateBegin', w3,
                    'DateEnd', w3,
                    'ShopId', w0,
                    'PromoCampaign', w0
                ]);
            }
        }
    }
}
